import { render, staticRenderFns } from "./RVBCustomers.vue?vue&type=template&id=7b368e32&scoped=true"
import script from "./RVBCustomers.vue?vue&type=script&lang=js"
export * from "./RVBCustomers.vue?vue&type=script&lang=js"
import style0 from "./RVBCustomers.vue?vue&type=style&index=0&id=7b368e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b368e32",
  null
  
)

export default component.exports